import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/storage.service';
import { LoginService } from '../../../core/services/login.service';
import { AssessmentModalComponent } from 'src/app/components/assessment-modal/assessment-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'src/app/core/services/common.service';
import { LanguageModalComponent } from 'src/app/components/language-modal/language-modal.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showLogo!: boolean;
  userName!: string;
  isArabic!: boolean;
  isChecker!: boolean;
  CustomerType?: string;
  modalRef!: BsModalRef;
  public loginErrResp: string = '';
  public loginErrMsg: string = '';
  isLoginFailed: boolean = false;
  accounts: any = []
  showPopupAccount: boolean = false;
  constructor(private loginService: LoginService, private route: Router,
    private storageService: StorageService) {
    route.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        this.showLogo = currentUrl.includes('submit-assessment') ? false : true;
      }
    });
  }

  ngOnInit(): void {
    this.accounts = this.storageService.getSessionStorageData('accounts');
    if (this.accounts && Array.isArray(this.accounts) && this.accounts.length > 1) {
      this.showPopupAccount = true
    }
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    const userData = this.storageService.getSessionStorageData('userDetails');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');

    this.userName = `${userData?.firstname ?? ''} ${userData?.lastname ?? ''}`.trim();

    /*
    this.CustomerType = (userData?.recordType?.toLowerCase() === 'dso' ?
      (userData?.customerGroup?.toLowerCase() === 'ifza' ? 'IFZA' : 'DSO')
      : userData?.recordType) ?? null;
    */

    // Or simplified logic:
    this.CustomerType = (userData?.customerGroup?.toLowerCase() === 'ifza')
      ? 'DSO-IFZA'
      : userData?.recordType ?? null;
  }

  logout() {
    this.loginService.logoutUser();
  }

  goToUserProfile() {
    this.route.navigate(['executor-dashboard/user-profile']);
  }

  goToDashboard() {
    if (this.isChecker) {
      this.route.navigate(['executor-dashboard/progress-tracker']);
    } else {
      this.route.navigate(['executor-dashboard/assessment']);
    }

  }

  chooseLanguage(isArabic: boolean) {
    this.storageService.setSessionStorageData('isArabic', isArabic);
    //  this.route.navigate([this.route.url]);
    window.location.reload();
  }

  switchAccount() {
    this.loginService.openAssessmentModal()
  }

}
